/**
 * Format price with Intl API
 */
export const intlPrice = (value, currency, locale, currencyDisplayDI = 'narrowSymbol') => {
    function format(currencyDisplay) {
        return new Intl.NumberFormat(locale, {
            style: 'currency',
            currency,
            currencyDisplay,
        }).format(value || 0);
    }
    try {
        return format(currencyDisplayDI);
    }
    catch (err) {
        try {
            // Fallback to symbol for older browsers
            // which don't support `narrowSymbol`.
            // Tested with Safari 12.1 (CS-2201)
            return format('symbol');
        }
        catch (err) { }
    }
    return `${value.toFixed(2)} [?]`;
};
/**
 *
 */
export const parseUnitName = (unitName, productName) => {
    if (unitName === 'Default Title') {
        return '';
    }
    return unitName
        .replace(new RegExp(`^${escapeRegExp(productName || '')}`), '')
        .trim();
};
// Reference from https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions#escaping
function escapeRegExp(text) {
    return text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
}
